import React from 'react';
import style from './block.module.scss';
import { useSmartProp, defineBlock, smartProps, useInspectorControl, useEditor } from '@smartfire/js-block-engine';
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';

function Inspector() {
    const [label, setLabel] = useSmartProp('label');
    const [url, setUrl] = useSmartProp('url');

    return (
        <>
            <PanelBody title="Button props" initialOpen={true}>
                <PanelRow>
                    <TextControl
                        label={'Label'}
                        value={label}
                        onChange={(val) => {
                            setLabel(val);
                        }}
                    />
                </PanelRow>
                <PanelRow>
                    <TextControl
                        label={'Lien'}
                        value={url}
                        onChange={(val) => {
                            setUrl(val);
                        }}
                    />
                </PanelRow>
            </PanelBody>
        </>
    );
}

function Block({ url, onClick, label }) {
    const { isEditing } = useEditor();
    useInspectorControl(Inspector);

    return (
        <div className={style.block}>
            <a
                href={isEditing || !url ? () => false : url}
                onClick={isEditing || !onClick ? () => false : onClick}
                className={style.button}
                rel="noreferrer"
            >
                <span>{label}</span>
            </a>
        </div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        url: smartProps.string.withDefault(''),
        label: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Button',
    },
});
